/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import Image from '@/components/NextImage';
import styles from './styles.module.scss';
import { View, Text } from '@az/starc-ui';
import { useLabels } from '@/hooks/useLabels';

const labelMap = {
  sweepstakesEntry: 'label_reviews_incentivizedReview',
};

export const Sweepstakes = () => {
  const labels = useLabels(labelMap);

  return (
    <View className={styles.badgeContainer}>
      <View direction={'row'} align={'center'} justify={'center'}>
        <Image aria-hidden src={'/images/reviews/gift.svg'} height={15} width={15} alt="" />
      </View>
      <Text variant="small-body" weight="bold">
        {labels.sweepstakesEntry}
      </Text>
    </View>
  );
};
